module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/364271f368dde9380cfef3da353be7c9.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/platinum.png
// module id = 5QYw
// module chunks = 0